export default __webpack_public_path__ + "static/media/screen1.80c04abc.png";